import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { Observable } from 'rxjs'
import { FORBBIDEN_EMAILS, FORBBIDEN_USERNAMES } from '../constants/user'

export class FormValidators {
	static forbiddenUsernamesValidator(control: FormControl): Record<string, boolean> | null {
		if (FORBBIDEN_USERNAMES.includes(control.value)) {
			return { 'nameIsForbidden': true }
		}
		return null
	}

	static notBlankValidator(control: AbstractControl): ValidationErrors | null {
		const value = control.value
		if (typeof value !== 'string' || value.trim().length === 0) {
			return { 'blank': true }
		}
		return null
	}

	static notZeroValidator(control: AbstractControl): ValidationErrors | null {
		const value = Number(control.value)
		if (control.value == null || control.value === '' || isNaN(value) || value === 0) {
			return { 'zero': true }
		}
		return null
	}

	static greaterThanZeroValidator(control: AbstractControl): ValidationErrors | null {
		const value = Number(control.value)
		if (control.value == null || control.value === '' || isNaN(value) || value <= 0) {
			return { 'notPositive': true }
		}
		return null
	}

	static forbiddenEmailsAsyncValidator(
		control: AbstractControl
	): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
		return new Promise<ValidationErrors | null>((resolve) => {
			setTimeout(() => {
				if (FORBBIDEN_EMAILS.includes(control.value)) {
					resolve({ 'emailIsForbidden': true })
				} else {
					resolve(null)
				}
			}, 1200)
		})
	}

	/**
	 * Group validator - marks `differentControlName` with `sameValue` error when its value equals the value of `controlName`.
	 */
	static differentValidator(controlName: string, differentControlName: string): ValidatorFn {
		return (abstractControl: AbstractControl) => {
			const control = abstractControl.get(controlName)
			const differentControl = abstractControl.get(differentControlName)
			if (differentControl?.errors && !differentControl?.errors?.['sameValue']) {
				return null
			}

			if (differentControl?.value && control?.value === differentControl.value) {
				const error = { 'sameValue': true }
				differentControl.setErrors(error)
				return error
			} else {
				differentControl?.setErrors(null)
				return null
			}
		}
	}

	static matchValidator(controlName: string, matchingControlName: string, errorText: string): ValidatorFn {
		return (abstractControl: AbstractControl) => {
			const control = abstractControl.get(controlName)
			const matchingControl = abstractControl.get(matchingControlName)
			if (matchingControl?.errors && !matchingControl?.errors?.['confirmedValidator']) {
				return null
			}

			if (control?.value !== matchingControl?.value) {
				const error = { 'confirmedValidator': errorText }
				matchingControl?.setErrors(error)
				return error
			} else {
				matchingControl?.setErrors(null)
				return null
			}
		}
	}
}
